export const RailAmount = "VSANZ_066";
export const CarriageAmountRail1 = "V_S1_AE_066";
export const CarriageAmountRail2 = "V_S2_AE_066";
export const HeightSorting = "VSORT_066";

export const MaterialName = "VH_MKB_066";
export const SizeCode = "VBGR_066";

export const Coating = "VBSCH_066";
export const Accuracy = "VGEN_066";
export const Preload = "VVSP_066";

export const RailLocatingFaceSegment1 = "V_S1_ANS_066";
export const CarriageLocatingFaceSegment1 = "V_S1_ANW_066";
export const RailLocatingFaceSegment2 = "V_S2_ANS_066";
export const CarriageLocatingFaceSegment2 = "V_S2_ANW_066";

export const GreasingPerGreaseGroup = "VBGG_066";
export const GreasingLType = "VBLT_066";

export const SectionHeight = "VHOE_066";

export const MountingHoleType = "VSBF_066"; // Rail mounting hole type
export const GuidewayDesign = "VSAF_066"; // Guideway design
export const CounterboreChamfered = "VSSBG_066"; // Counterbore Chamfered

export const SMDS = "VSMDS_066";

export const PartSizing = "VVST_066"; // Possible values: No parts, automatic split, manual split
export const PartAmount = "VTLA_066";

export const FakeLength = "FAKE_CSTIC_UNIT_LENGTH";
